<div class="wrapper" title="{{ status |  translate }}">
	<img src="assets/images/dashboard/{{ status | lowercase }}.png"/>
</div>